module.exports = function(){








    /*------------------------------------*\
        get attribute even it the object
        does not exist (very naive)
    \*------------------------------------*/
    window.getattr = function(invokation){
        try {
            return eval(invokation);
        } catch(e) {
            return null;
        }
    };


    /*------------------------------------*\
        get URL GET parameter
    \*------------------------------------*/
    window.getget = function(name){
       if(name=(new RegExp('[?&]'+encodeURIComponent(name)+'=([^&]*)')).exec(location.search))
          return decodeURIComponent(name[1]);
    }


    /*------------------------------------*\
        make first letter uppercase
    \*------------------------------------*/
    String.prototype.capitalize = function() {
        return this.charAt(0).toUpperCase() + this.slice(1);
    };



    /*------------------------------------*\
        push unique
        http://stackoverflow.com/a/12877785
    \*------------------------------------*/
    Array.prototype.pushUnique = function (item){
        if(this.indexOf(item) == -1) {
        //if(jQuery.inArray(item, this) == -1) {
            this.push(item);
            return true;
        }
        return false;
    };


    /*------------------------------------*\
        serializeFormJSON
    \*------------------------------------*/
    $.fn.serializeFormJSON = function () {
        var o = {};
        var a = this.serializeArray();
        $.each(a, function () {
            if (o[this.name]) {
                if (!o[this.name].push) {
                    o[this.name] = [o[this.name]];
                }
                o[this.name].push(this.value || '');
            } else {
                o[this.name] = this.value || '';
            }
        });
        return o;
    };


    /*------------------------------------*\
        debounce
        https://remysharp.com/2010/07/21/throttling-function-calls
    \*------------------------------------*/
    window.debounce = function(fn, delay) {
        var timer = null;
        return function () {
            var context = this, args = arguments;
            clearTimeout(timer);
            timer = setTimeout(function () {
                fn.apply(context, args);
            }, delay);
        };
    };



    /*------------------------------------*\
        notice using jBox plugin
    \*------------------------------------*/
    window.notice = function(text){

        alertify
            .maxLogItems(10)
            .logPosition('bottom right')
            .closeLogOnClick(true)
            .log(text)
            .reset();

        //new jBox('Notice', {
        //    content: text,
        //    attributes: { x: 'right', y: 'bottom' },
        //});


    };



    /*------------------------------------*\
        throttle
        https://remysharp.com/2010/07/21/throttling-function-calls
    \*------------------------------------*/
    window.throttle = function(fn, threshhold, scope) {
        threshhold || (threshhold = 250);
        var last,
            deferTimer;
        return function () {
            var context = scope || this;

            var now = +new Date,
                args = arguments;
            if (last && now < last + threshhold) {
                // hold on to it
                clearTimeout(deferTimer);
                deferTimer = setTimeout(function () {
                    last = now;
                    fn.apply(context, args);
                }, threshhold);
            } else {
                last = now;
                fn.apply(context, args);
            }
        };
    };



    /**
     *  Console.frog. A better way to log!
     *    - Logs a frog, saying your log... Yep!
     *
     *  MIT licensed
     *  Copyright (C) 2016 Tim Holman, http://tholman.com
     */

    (function dothething() {

      if( !window.console ) {
        // Well... nothing really... let it be!
        return;
      }

      window.console.frog = function() {

        var i;

        // This looks like a frog, right?
        // Taken from here - http://chris.com/ascii/index.php?art=animals/frogs
        var frog = [[""],
                    ["         _,-.  "],
                    [" ,-. ,--'  o ) "],
                    [" \\(,' '  ,,-' "],
                    [",-.\\-.__,\\\\_"],
                    ["\\(`--'    `\\ "],
                    [""]];

        // Gets args as a string
        var args = Array.prototype.slice.call(arguments);
        var stringOfArgs = args.join(' ');

        // Add the bubble if there is something to log!
        if( stringOfArgs.length > 0 ) {
          frog[1] = frog[1] + "   ---" + ("-".repeat(stringOfArgs.length)) + "-";
          frog[2] = frog[2] + "-(   " + stringOfArgs + "   )";
          frog[3] = frog[3] + "    ---" + ("-".repeat(stringOfArgs.length)) + "-";
        }

        // Log the frog!
        for( i = 0; i < frog.length; i++ ) {
          console.log(frog[i] + "\n");
        }
      }

      // console.log(console.frog);
    })();



}; // end of module.exports




// WEBPACK FOOTER //
// ./js-source/base/utilities.js